import React from 'react';
import { WebBlocksApiBlockWithCorrelationIdT } from '../../../lib/REST/types';
import { BlocksFunctionsType } from '../types';
import { BlockReplacer } from '../BlockReplacer';

type BlocksReplacerPropsType = {
	blocks: WebBlocksApiBlockWithCorrelationIdT[];
} & BlocksFunctionsType;

export function BlocksReplacer({
	blocks,
	clickLinkData,
	onAppear,
	onRendered,
}: BlocksReplacerPropsType) {
	if (!blocks || !blocks.length) {
		return null;
	}

	return (
		<>
			{blocks.map(
				({ contentId, campaignId, correlationId, customJs, replacements }) => {
					const BlockReplacerInfo = {
						contentId,
						correlationId,
						campaignId,
						customJs,
						replacements,
					};

					return (
						<BlockReplacer
							{...BlockReplacerInfo}
							onAppear={onAppear}
							onRendered={onRendered}
							clickLinkData={clickLinkData}
							key={campaignId}
						/>
					);
				}
			)}
		</>
	);
}
